import React from "react";

const Bash_Cut = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Cut</h2>
      <p>Remove sections from each line of files.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>cut [options] [file]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>cut -d',' -f1 data.csv
cat file | cut -c1-10</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Commonly used to extract columns.</p>
    </div>
  );
};

export default Bash_Cut;
